<template>
  <el-dialog
    :title="title"
    :visible.sync="visiable"
    :close-on-click-modal="false"
    width="600px"
    @close="onClose()"
  >
    <el-form
      :model="replyInfo"
      :rules="rules"
      ref="replyInfo"
      label-width="100px"
      class="messageTip"
    >
      <!-- 只读 -->
      <div class="">
        <el-form-item :label="$t('createOrder.createOrder102') + ':'">
          <span>{{ userName }}</span>
        </el-form-item>
        <el-form-item
          class="messageType"
          :label="$t('createOrder.createOrder103') + ':'"
          label-width="auto"
        >
          <span>{{ messageType }}</span>
        </el-form-item>

        <el-form-item
          v-if="orderNo"
          :label="$t('createOrder.createOrder104') + ':'"
        >
          <span>{{ orderNo }}</span>
        </el-form-item>
      </div>
      <!-- <el-form-item label="模板:">
        <el-select v-model="replyInfo.remindingTitleJa" placeholder="请选择" @change="onChange">
          <el-option v-for="item in messageList" :key="item.id" :value="item.remindingTitle" :label="item.remindingTitle">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- 内容 -->
      <el-form-item
        :label="$t('createOrder.createOrder105') + ':'"
        prop="remindingTitle"
      >
        <el-input v-model="replyInfo.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item
        style="padding-top: 10px"
        :label="$t('createOrder.createOrder106') + ':'"
        prop="remindingContent"
      >
        <quill-editor
          ref="text"
          v-model="replyInfo.remindingContent"
          :options="editorOption"
        />
      </el-form-item>
      <!-- <el-form-item label="跳转链接:" prop="url">
        <el-input v-model="replyInfo.url"></el-input>
      </el-form-item> -->
      <!-- 上传图片 -->
      <el-form-item
        style="padding-top: 10px"
        :label="$t('createOrder.createOrder107') + ':'"
      >
        {{ replyInfo.replyPicture }}
        <el-upload
          class="editor-slide-upload"
          action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com"
          :data="imgDataObj"
          accept="image/png,image/jpeg,video/mp4"
          :file-list="listObj"
          list-type="picture-card"
          :show-file-list="true"
          :on-remove="handleImgRemove"
          :on-preview="handlePictureCardPreview"
          :on-success="handleImgSuccess"
          :before-upload="beforeImgUpload"
          :limit="9"
          :on-exceed="handleExceed"
          :multiple="true"
          :auto="true"
        >
          <!-- <template #file="{file}">
            {{ file }}
          </template> -->
          <el-button size="small" type="primary">{{
            $t("createOrder.createOrder20")
          }}</el-button>
          <div ref="preview" @paste="handlePaste" class="paste-img"></div>
        </el-upload>
        <el-dialog :append-to-body="true" :visible.sync="viewVisible">
          <img width="100%" :src="viewImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <!-- 上传附件 -->
      <el-form-item :label="$t('mess.mess45') + ':'">
        <el-upload
          class="editor-slide-upload"
          action=""
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUploadFile"
          :before-remove="beforeRemove"
          :on-success="handleOrderInfo"
          :show-file-list="true"
          :multiple="true"
          :limit="3"
          :on-exceed="handleAnnexExceed"
          :file-list="attachmentList"
          :http-request="excelUploadRequest"
        >
          <el-button class="search-btn btn-blue">{{
            $t("createOrder.createOrder20")
          }}</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button class="form-btn btn-gray" @click="onClose">{{
        $t("cancel")
      }}</el-button>
      <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{
        $t("submit")
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Oss from "@/assets/js/oss.js";
const toolbarOptions = [
  ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
];
export default {
  name: "MessageTip",
  props: {
    title: {
      type: String,
      default: "",
    },
    visiable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
    userName: {
      type: String,
      default: "",
    }, // 用户id
    messageType: {
      type: String,
      default: "",
    }, // 消息类型
    orderNo: {
      type: [String, Number],
      default: "",
    }, // 订单编号
    httpUrl: {
      type: String,
      default: "",
    }, // 请求地址
  },
  data() {
    return {
      viewImageUrl: "",
      viewVisible: false,
      messageList: [],
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
        },
      },
      replyInfo: {
        id: "",
        orderId: "",
        remindingUserName: "",
        remindingTitle: "",
        // remindingTitleJa: '',
        remindingContent: "",
        // url: '',
        replyPicture: "",
        attachment: "",
      },
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      rules: {
        // remindingTitleJa: [
        //   { required: true, message: '请输入标题', trigger: 'blur' }
        // ],
        remindingTitle: [
          {
            required: true,
            message: this.$t("orderList.orderList62"),
            trigger: "blur",
          },
        ],
        remindingContent: [
          {
            required: true,
            message: this.$t("orderList.orderList63"),
            trigger: "blur",
          },
        ],
      },
      attachmentList: [],
      listObj: [],
    };
  },
  watch: {
    visiable(val) {
      if (val) {
        this.attachmentList = [];
        this.listObj = [];
        this.doReset();
        // .then(() => {
        //   this.getMessageList()
        // })
      }
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.viewImageUrl = file.url;
      this.viewVisible = true;
    },
    async handlePaste(event) {
      const files = (event.clipboardData || window.clipboardData).files;
      if (!files || files.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (const file of files) {
        if (file) {
          if (file.type.indexOf("image") === -1) {
            return this.$message.error("粘贴内容非图片");
          }
          let formdata = new FormData();
          formdata.append("file", file);
          // 数据保存
          const { data: res } = await this.$http.post(
            "cmUser/message/uploadFile",
            formdata
          );
          if (res.code === 200) {
            this.listObj.push({
              name: res.data.fileName,
              url: res.data.filePath,
              hasSuccess: true,
              uid: Date.now(),
            });
          }
        }
      }
    },
    // onChange (val) {
    //   const obj = this.messageList.find(item => item.remindingTitle === val)
    //   // this.replyInfo.remindingTitle = obj.remindingTitleJa
    //   this.replyInfo.remindingContent = obj.remindingContentJa
    //   // this.replyInfo.url = obj.url
    // },
    // getMessageList () {
    //   this.$http.get('template/message/getList').then(res => {
    //     this.messageList = res.data.data
    //   })
    // },
    replySave(formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
        } else {
          this.$message.error(this.$t("orderList.orderList104"));
          return false;
        }
      });
    },
    async addReply() {
      //添加
      if (!this.handleImgSubmit()) {
        return false;
      }
      this.replyInfo.orderId = this.orderNo;
      this.replyInfo.remindingUserName = this.userName;
      this.replyInfo.id = this.id;

      return
      const { data: res } = await this.$http.post(this.httpUrl, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.$emit("confirm");
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
    },
    handleImgSubmit() {
      var _this = this;
      let arr = [];
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v].url);
      });

      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t("orderList.orderList105"));
        return false;
      } else {
        if (arr.length > 9) {
          _this.$message.error(this.$t("orderList.orderList138"));
          return false;
        } else {
          _this.replyInfo.replyPicture = arr.toString();
          _this.listObj = [];
        }
        if (_this.attachmentList.length > 0) {
          _this.replyInfo.attachment = JSON.stringify(this.attachmentList);
        } else {
          _this.replyInfo.attachment = "";
        }
      }
      return true;
    },
    handleImgRemove(file, fileList) {
      // 显示使用
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess(response, file) {
      console.log('response',response)
      console.log('response',file)
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      console.log('imgSuccess',file)
      console.log('imgSuccess',this.listObj)
      console.log('imgSuccess',this.imgDataObj)
    },
    beforeImgUpload(file) {
      const _self = this;
      if (
        ['image/jpeg,image/jpg,image/png,vodeo/mp4'].includes(file.type)
      ) {
        _self.$message.error(this.$t("createOrder.createOrder74"));
        return false;
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/;
      if (specialReg.test(file.name)) {
        _self.$message.error(this.$t("createOrder.specialChar"));
        return false;
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/order";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;

              Oss.imgCompress(file, this.listObj, resolve, reject);

          })
          .catch(() => {
            reject(true);
          });
      });
    },
    handlePreview() {
      // console.log(file);
    },
    handleRemove(file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1);
        }
      }
    },
    beforeUploadFile(file) {
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      // const size = file.size / 1024 / 1024
      if (
        extension !== ".xls" &&
        extension !== ".xlsx" &&
        extension !== ".pdf" &&
        extension !== ".mp4"
      ) {
        this.$message.warning(this.$t("orderList.orderList137"));
        return false;
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    beforeRemove() {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}?`);
    },
    // 批量导入成功回调
    handleOrderInfo() {
      console.log("success");
      // console.log(data)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder118")},${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")},${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      );
    },
    handleAnnexExceed(files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder119")},${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")},${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      );
    },
    // 批量导入
    async excelUploadRequest(file) {
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      );
      if (res.code === 200) {
        let { fileName, filePath } = res.data;
        this.attachmentList.push({ name: fileName, url: filePath });
      }
    },
    onClose() {
      this.$emit("update:visiable", false);
    },
    doReset() {
      return new Promise((resolve) => {
        this.replyInfo.remindingTitle = "";
        // this.replyInfo.remindingTitleJa = '',
        this.replyInfo.remindingContent = "";
        // this.replyInfo.url = '',
        this.replyInfo.replyPicture = "";
        this.attachmentList = [];
        this.listObj = [];
        resolve();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.paste-img {
  position: absolute;
  top: 0;
  left: 1px;
  width: 1px;
  height: 1px;
  z-index: 999;
}
</style>
